import { trpc, useCatalog, useSession, type Catalog } from '@tg/app-core';
import { useMemo } from 'react';
import { localToday } from './dates';
import { maxesOf, type MaxRow } from './workout';

/* Общие запросы экранов. Всё — из API, демо-данных в коде нет. */

export function useMe() {
  const s = useSession();
  return trpc.clientApp.me.useQuery(undefined, { enabled: !!s && s.role === 'client', staleTime: 60_000 });
}

/** «Сегодня» — в часовом поясе тренера (с сервера), без сети — по часам телефона */
export function useToday() {
  const me = useMe();
  return me.data?.today || localToday();
}

export function useMaxes() {
  const q = trpc.clientApp.maxes.useQuery(undefined, { staleTime: 60_000 });
  const rows = (q.data || []) as unknown as MaxRow[];
  const pm = useMemo(() => maxesOf(rows), [rows]);
  const pm3 = useMemo(() => maxesOf(rows, 3), [rows]);
  return { q, rows, pm, pm3 };
}

export { useCatalog };

/* Подписи общих ключей 1ПМ: ключ объединяет вариации одного движения
   (присед со штангой, с паузой…), поэтому имя короче названия упражнения */
const PM_NAMES: Record<string, string> = {
  squat: 'Присед',
  fsquat: 'Фронт. присед',
  dead: 'Становая',
  bench: 'Жим лёжа',
  press: 'Жим стоя',
  clean: 'Взятие на грудь',
  snatch: 'Рывок',
  jerk: 'Толчок',
  rdl: 'Румынская тяга',
  ohsquat: 'Присед над головой',
};
export function pmName(key: string, cat: Catalog) {
  if (PM_NAMES[key]) return PM_NAMES[key];
  const e = cat.ex(key) || cat.list.find((x) => x.pm === key);
  return e?.ru || key;
}

/** Номер для показа: «+7 900 000-00-00», «+375 29 123-45-67» */
export { phoneView as phoneShow } from '@tg/domain';

export const initials = (first?: string | null, last?: string | null) => (((first || '')[0] || '') + ((last || '')[0] || '')).toUpperCase();
export const fmtN = (v: number | null | undefined, dec?: boolean) => (v == null ? '—' : String(dec ? Math.round(v * 10) / 10 : v).replace('.', ','));
